import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithReauth from '../../app/baseQueryWithOnlineCourse'
import { VideoNotesAnalysisState } from '../types'

interface getStudentTopicVideonotesAnalysisParams {
    courseSubjectId: number
    userCourseEnrollId: number
}

export const videonotesApiSlice = createApi({
    reducerPath: 'videonotesApi',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['Videonotes'],
    endpoints: (build) => ({

        gradeVideonotes: build.mutation<any, { body: { videoNotesId: number, point: number, feedback: string } }>({
            query: ({ body }) => ({
                url: `video-notes/evaluate`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: 'Videonotes', id: 'LIST' }],
        }),

        getStudentTopicVideonotesAnalysis: build.query<
            VideoNotesAnalysisState[],
            getStudentTopicVideonotesAnalysisParams
        >({
            query: ({ courseSubjectId, userCourseEnrollId }) => ({
                url: `video-notes/curator/${userCourseEnrollId}?courseSubject=${courseSubjectId}`,
            }),
            providesTags: (result) =>
                result
                    ? [
                        ...result.map(({ id }) => ({
                            type: 'Videonotes' as const,
                            id,
                        })),
                        { type: 'Videonotes', id: 'LIST' },
                    ]
                    : [{ type: 'Videonotes', id: 'LIST' }],
            transformResponse: (response: any) => response.data,
        }),
    }),
})     